import { render } from "./SobreView.vue?vue&type=template&id=080b9cb1"
import script from "./SobreView.vue?vue&type=script&lang=js"
export * from "./SobreView.vue?vue&type=script&lang=js"

import "./SobreView.vue?vue&type=style&index=0&id=080b9cb1&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Sub4Turismo\\FrontSite\\CodigoVueSub4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__